import { IOrderLine } from '../../../../models/Orders/IOrderLine';
import styles from './OrdersCard.module.css';

type OrderProps = {
  orderLine: IOrderLine;
  orderNumber: string;
  handleOrderPrint: (orderNumber: string) => void;
};

const OrdersCard = (props: OrderProps) => {
  return (
    <div className={styles.ordersDonationsCard}>
      <div className={styles.orderDetailsContainer}>
        <div className={styles.productInfoDate}>{props.orderLine.orderDate}</div>
        <div className={styles.productInfoTitle}>{props.orderLine.description}</div>
        <div className={styles.productInfoNumber}>
          <strong>ORDER NUMBER: </strong>
          {props.orderLine.tracking}
        </div>
        <div className={styles.productInfoTotal}>
          <strong>TOTAL: </strong> ${props.orderLine.totalAmount}
        </div>
      </div>
      <div
        onClick={() => props.handleOrderPrint(props.orderNumber)}
        className={styles.printButtonContainer}
      >
        <div className={styles.printButton}>View Order History</div>
      </div>
    </div>
  );
};

export default OrdersCard;
